export default {"src":"/_next/static/media/kp.e61f6448.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};